import { render, staticRenderFns } from "./CategoryNavBar.vue?vue&type=template&id=22659199&"
import script from "./CategoryNavBar.vue?vue&type=script&lang=js&"
export * from "./CategoryNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports